import { AbilityBuilder, createMongoAbility } from '@casl/ability';
import type { RawRuleOf } from '@casl/ability';
import type { CompanyWorkspaceAccessContext } from '@/abilities/companyWorkspace/context';
import { COMPANY_WORKSPACE_DESTINATION, type CompanyWorkspaceAbility } from '@/abilities/companyWorkspace/vocabulary';

export const companyWorkspaceRules = ({
  inWorkspaceRoles,
  inConfidentialWorkspaceRoles,
}: CompanyWorkspaceAccessContext): RawRuleOf<CompanyWorkspaceAbility>[] => {
  const { can, rules } = new AbilityBuilder<CompanyWorkspaceAbility>(createMongoAbility);
  if (inWorkspaceRoles) {
    can(['see', 'open'], COMPANY_WORKSPACE_DESTINATION, { destination: 'standard' });
  }
  if (inConfidentialWorkspaceRoles) {
    can(['see', 'open'], COMPANY_WORKSPACE_DESTINATION, { destination: 'confidential' });
  }
  return rules;
};
